import { ReassignItemRequestState } from './reassignItemRequest.types'

const initialState: ReassignItemRequestState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
